import React from 'react';
import { connect } from 'react-redux';
import './age_gate.css';
import Render from './render';
import Storage from '../../services/storage';
import { AGE_GATE_VALIDATED, AGE_GATE_NOT_VALIDATED } from '../../constants/actions';
import get from 'lodash.get';

class AgeGate extends React.Component<any> {
  public get isValidatedAge() {
    return get(this.props, 'ageGate.validated');
  }

  public get isValidatedAgeDefined() {
    return this.isValidatedAge === !!this.isValidatedAge;
  }

  public get dispatch() {
    return this.props.dispatch;
  }

  confirm = () => {
    Storage.set('ageGate', true);
    this.dispatch({ type: AGE_GATE_VALIDATED });
  };

  deny = () => {
    this.dispatch({ type: AGE_GATE_NOT_VALIDATED });
  };

  render() {
    return Render.call(this, this.props, this.state);
  }
}

const state = ({
  ageGate,
  surgeonWarning: { warning },
}) => ({
  ageGate,
  warning
});

export default connect(state)(AgeGate);



// WEBPACK FOOTER //
// ./src/containers/AgeGate/index.tsx